@let npItem = timeline.nowPlayingItem();
@if (playerVisible()) {
  <div class="bottom-sheet flex flex-col justify-end w-full" [ngClass]="bottomSheetKlasses()">
    @if (!expanded()) {
      <div class="p-1 text-light playlist-column ">
        <ng-container *ngTemplateOutlet="miniPlayer"></ng-container>
      </div>
    } @else {
      <div
        class="playlist-column text-default-200 bg-default-950 xs:p-2 rounded-lg sm:mb-2 sm:rounded-2xl sm:shadow-2xl">
        <div class="relative">
          <nav class="flex justify-center items-center  p-1 pt-2 text-default-primary-300 gap-1 xs:gap-2">
            <div [ngClass]="mixInfoNavKlasses()">
              <button (click)="showMixInfoEvent()" class="w-25 xs:w-28">Show Info</button>
            </div>
            <div [ngClass]="playlistNavKlasses()">
              <button (click)="showPlaylistEvent()" class="w-34">Recently Played</button>
            </div>
            <div [ngClass]="steeringWheelNavKlasses()">
              <button (click)="showSteeringWheelEvent()" class="w-25 xs:w-28">Up Next</button>
            </div>
          </nav>
        </div>

        <ng-container *ngTemplateOutlet="expandedViewsTemplate"></ng-container>

        <div class="pr-3 text-right py-2 -mb-8 lg:-mb-6 z-50">
          <button (click)="toggleExpandedEvent($event)" aria-label="Hide expanded player" title="Contract Player"
                  class="rounded-full size-11 sm:size-9 text-lg border-2 bg-default-990 border-default-500">
            <fa-icon [icon]="faContractIcon"></fa-icon>
          </button>
        </div>

        <ng-container *ngTemplateOutlet="maxiPlayer"></ng-container>
      </div>

    }
  </div>
}

<ng-template #expandedViewsTemplate>
  @if (expandedView() !== ExpandedViews.None) {
    <div class="playlist-column text-light pt-1">
      <div class="expanded-content min-h-90">
        @switch (expandedView()) {
          @case (ExpandedViews.MixInfo) {
            @if (npItem) {
              <div class="bg-default-990 p-2 sm:rounded-lg min-h-60">
                <div class="text-lg hidden sm:mb-1">You're listening to</div>
                <kexp-mix-and-segment [item]="npItem"></kexp-mix-and-segment>
              </div>
            }
          }
          @case (ExpandedViews.SteeringWheel) {
            <div class="mx-2 sm:mx-0 pt-2">
              <kexp-steering-wheel [steeringMode]="SteeringMode.UpNext" [onDialog]="false"
                                   (pathTaken)="steeringPathTaken()"></kexp-steering-wheel>
            </div>
          }
          @case (ExpandedViews.Playlist) {
            <div>
              <div class="bg-default-990 px-1 sm:py-1 sm:rounded-lg min-h-80 flex flex-col justify-between">
                <div>
                  @if (playlistHasItems()) {
                    <div>
                      <kexp-mini-playlist></kexp-mini-playlist>
                    </div>
                  } @else {
                    <div class="text-center pt-20">
                      Tracks will appear here once the first song has played
                    </div>
                  }
                </div>
                <div class="text-center my-1">
                  <button (click)="fullPlaylistEvent()" class="underline">Full Playlist</button>
                </div>
              </div>
            </div>
          }
        }
      </div>
    </div>
  }
</ng-template>

<ng-template #playerScrubBar>
  <div class="sm:flex w-full gap-2" aria-label="Playback Position" tabindex="0" role="progressbar"
       aria-valuemin="0" [aria-valuemax]="npSchedulingItemDuration()"
       [aria-valuenow]="npSchedulingItemPosition()" [aria-valuetext]="positionSpoken()">
    <div class="w-1/2 sm:w-18 sm:text-right text-sm inline-block">
      {{ npSchedulingItemPosition() | secondsToMinutes }}
    </div>
    <div class="w-1/2 sm:w-18 text-sm sm:order-3 inline-block ml-auto text-right sm:text-left">
      {{ (npSchedulingItemDuration() - npSchedulingItemPosition()) | secondsToMinutes }}
    </div>
    <div class="w-full self-center">
      <kexp-media-scrub-bar
        [schedulingItem]="npSchedulingItem()"
        [scrubBarSegments]="npScrubBarSegments()"
        (mediaClicked)="scrubBarClicked($event)"
      >
      </kexp-media-scrub-bar>
    </div>
  </div>
</ng-template>

<ng-template #playPauseButton>
  <div>
    <button (click)="togglePause()" class="playback-toggle" [disabled]="PlayerControlState.Indeterminate"
            title="playPauseButtonLabel()" aria-label="playPauseButtonLablel()">
      @switch (controlState()) {
        @case (PlayerControlState.Play) {
          <fa-duotone-icon [icon]="playIcon" secondaryOpacity="1"></fa-duotone-icon>
        }
        @case (PlayerControlState.Pause) {
          <fa-duotone-icon [icon]="pauseIcon" secondaryOpacity="1"></fa-duotone-icon>
        }
        @case (PlayerControlState.Indeterminate) {
          <fa-duotone-icon [icon]="playIcon" secondaryOpacity="1"></fa-duotone-icon>
        }
      }
    </button>
  </div>
</ng-template>

<ng-template #maxiPlayer>
  <div class="text-default-200 bg-default-800 py-1 px-2 sm:px-1 rounded-b-lg xs:rounded-lg sm:rounded-xl">
    @if (npItem) {
      <div class="flex gap-2 sm:gap-3 pt-2">
        <div class="np-image size-12">
          @if (npImageUrl()) {
            <button (click)="showTrackInfoEvent()" class="cursor-pointer"
                    aria-label="Show More Info">
              <img [src]="npImageUrl()" [title]="npImageLabel()" aria-label=""
                   class="size-12"/>
            </button>
          }
        </div>
        <div class="flex-grow-2">
          <button (click)="showTrackInfoEvent()">
            <kexp-mini-track-info [content]="npItem.content"
                                  showAlbum="false"></kexp-mini-track-info>
          </button>
        </div>
      </div>
    }
    <div class="flex items-center justify-center">
      <div class="">
        <div class="player-control-button rounded-full text-sm pl-2 pr-3 py-1 mx-1">
          <button (click)="fastForward()">
            <fa-icon [icon]="forwardIcon"></fa-icon>
            10 min
          </button>
        </div>

        @if (skipButtonTitle()) {
          <div class="player-control-button rounded-full text-sm pl-2 pr-3 py-1 mx-1">
            <button (click)="skipToNextSegment()">
              <fa-icon [icon]="skipIcon"></fa-icon>
              {{ skipButtonTitle() }}
            </button>
          </div>
        }
      </div>
      <ng-container *ngTemplateOutlet="playPauseButton"></ng-container>
    </div>
    <div class="sm:py-1">
      <ng-container *ngTemplateOutlet="playerScrubBar"></ng-container>
    </div>
  </div>

</ng-template>

<ng-template #miniPlayer>
  <div class="rounded-full bg-default-800 text-default-200 p-2 ps-6 mb-2 shadow-2xl  flex items-center sm:h-18">
    @if (ranOutOfContent()) {
      <div class="">
        <button (click)="toggleExpandedEvent($event)" class="text-center text-lg w-full">
          Show complete! Would you like to listen to something else?
        </button>
      </div>
    } @else {
      @if (npImageUrl()) {
        <div class="hidden sm:inline-block sm:mr-2">
          <button (click)="toggleExpandedEvent($event)" class="text-left w-full" aria-label="Show expanded player">
            <img [src]="npImageUrl()" alt="" aria-label="" class="size-12" [title]="npImageLabel()"/>
          </button>
        </div>
      }

      <div class="flex-grow-1">
        <button (click)="toggleExpandedEvent($event)" class="text-left w-full" aria-label="Show expanded player" title="Expand Player">
          <kexp-mini-track-info [content]="timeline.nowPlayingItem()?.content"
                                [showAlbum]="false"></kexp-mini-track-info>
        </button>
      </div>
    }
    <div class="ml-auto">
      <ng-container *ngTemplateOutlet="playPauseButton"></ng-container>
    </div>
  </div>
</ng-template>
